import {ServiceService} from '@/common/api/service.service'
import {
    SERVICE_CREATE,
    SERVICE_EDIT,
    SERVICE_DELETE,
    SERVICE_GET,
    SERVICES_GET,
    SERVICES_BM_GET,
    CATEGORIES_GET,
    SERVICE_ACTIVE,
    SERVICE_INACTIVE,
    SERVICE_SEARCH, SERVICES_SIMPLE_BM_GET
} from './actions/service.type.js'
import {
    SET_SERVICE,
    SET_SERVICES,
    SET_CATEGORIES,
    SET_SERVICE_PAGINATION,
    SET_SERVICE_ACTIVE,
    SERVICE_RESET,
    SERVICE_RESET_STATE, SET_SERVICES_SIMPLE, ADD_SERVICES_SIMPLE, REMOVE_SERVICES_SIMPLE,
} from './mutations/service.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        service: {
            id: 0,
            active: false,
            name: "",
            desc: "",
            value: null,
            categoryID: 0,
            categoryName: "",

        },

        servicePagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },

        itemsPerPage: 10,
        services: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        servicesSimple: [],
        categories: [],

    }
}

export const state = initialState()

const getters = {
    service: state => {
        return state.service
    },
    services: state => {
        return state.services
    },
    servicesSimple: state => {
        return state.servicesSimple
    },
    servicePagination: state => {
        return state.servicePagination
    },
    categories: state => {
        return state.categories
    }
}

export const mutations = {
    [SET_SERVICE](state, data) {
        state.service = data
    },
    [SET_SERVICES](state, data) {
        state.services = data
    },
    [SET_SERVICES_SIMPLE](state, data) {
        state.servicesSimple = data
    },
    [ADD_SERVICES_SIMPLE](state, data) {
        state.servicesSimple.push(data)
    },
    [REMOVE_SERVICES_SIMPLE](state, id) {
        let index = state.servicesSimple.findIndex((element) => element.id == id)
        state.servicesSimple.splice(index, 1)
    },


    [SET_CATEGORIES](state, data) {
        state.categories = data
    },
    [SET_SERVICE_PAGINATION](state, data) {
        state.services.activePage = data.page
        state.servicePagination.itemsPerPage = data.itemsPerPage
        state.servicePagination.orderBy = data.orderBy
        state.servicePagination.sortDesc = data.sortDesc
    },
    [SET_SERVICE_ACTIVE](state, active) {
        state.service.active = active
    },
    [SERVICE_RESET](state) {
        Object.assign(state.service, initialState().service)
    },
    [SERVICE_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    async [CATEGORIES_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.list_categories()
        commit(SET_CATEGORIES, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [SERVICES_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.list()
        commit(SET_SERVICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [SERVICES_SIMPLE_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.listBM(id)
        commit(SET_SERVICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [SERVICE_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.get(id)
        commit(SET_SERVICE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [SERVICES_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.bmServices(id)
        commit(SET_SERVICES_SIMPLE, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [SERVICE_SEARCH]({commit, state}) {
        // commit(CHANGE_PROGRESS, true)
        const {data} = await ServiceService.search(
            state.services.activePage,
            state.servicePagination.itemsPerPage,
            state.services.active,
            state.servicePagination.search,
            state.servicePagination.orderBy,
            state.servicePagination.sortDesc)
        commit(SET_SERVICES, data)
        // commit(CHANGE_PROGRESS, false)
    },
    [SERVICE_CREATE]({state}) {
        return ServiceService.create(state.service)
    },
    [SERVICE_EDIT]({state}) {
        return ServiceService.update("", state.service)
    },
    [SERVICE_ACTIVE](_, id) {
        return ServiceService.active(id)
    },
    [SERVICE_INACTIVE](_, id) {
        return ServiceService.inactive(id)
    },
    [SERVICE_DELETE]({state}) {
        return ServiceService.delete(state.service.id)
    },
    [SERVICE_RESET_STATE]({commit}) {
        commit(SERVICE_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
